export function hasPermission(permission: string, userPermissions: string[]) {
  return userPermissions?.includes(permission);
}

// BG Report access is allowed only for users with jobs permission (Edit Job, Create Post)
export function hasBGReportAccess(userPermissions: string[]) {
  return hasPermission("jobs", userPermissions);
}

